mod.modules.define("AnnualRatesChange", "BaseModule", function (fn) {

    fn.prototype.reloadChart = function () {
        var measureButtons = this.getChartButtonCriteria("measures");
        var periodButtons = this.getChartButtonCriteria("periods");
        var periodSelect = this.getChartSelectCriteria();
        
        var criteria = {
            "SelectedMeasures": measureButtons,
            "SelectedPeriods":  periodButtons.concat(periodSelect)
        };
        
        //this.ajax(criteria, $.proxy(this.handleAjaxResponse, this));
        this.reload(criteria, false);
    };

    fn.prototype.handleAjaxResponse = function (response) {
        if (response.chart) {
            this.el.find("div.rateschange-chartwrapper").replaceWith(response.chart);
        }
    };

    fn.prototype.getChartButtonCriteria = function (criteriaType) {
        var actives = [];
        var activeButtons = this.el.find("[data-grouptype=" + criteriaType + "] .btn.active");

        for (var i = activeButtons.length - 1; i >= 0; i--) {
            var action = activeButtons.eq(i).attr("data-action");
            actives.push(action);
        }

        return actives;
    };

    fn.prototype.getChartSelectCriteria = function () {
        var actives = [];
        var periodString = this.el.find(".rateschange-periods select").val();

        if (periodString) {
            actives = JSON.parse(periodString);
        }

        return actives;
    };

    fn.prototype.events = {
        "[data-grouptype] .btn": {
            "click": function () {
                setTimeout($.proxy(this.reloadChart, this));
            }
        },
        ".rateschange-periods select": {
            "change": function () {
                setTimeout($.proxy(this.reloadChart, this));
            }
        }
    };

});